import React, { Fragment, useState } from "react"
import { Box, Card, Typography, CircularProgress } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import {
  toggleDigitalSignatureDialog,
  toggleSendBillingDialog,
} from "../../../../actions/billingDialogs"
import CheckIcon from "@material-ui/icons/Check"
import CloseIcon from "@material-ui/icons/Close"
import { updateCrewDealMemoStatus } from "../../../../actions/billing-crew-client"
import { openSnackBar } from "../../../../actions/snack-bar"
import PropTypes from "prop-types"
import moment from "moment"
import { _toggleLoginDialog } from "../../../../actions/authentication"
import styles from "./styles"
import GreenButton from "../../Common/GreenButton/index"
import LoadingButton from "../../../LoadingButton/index"
import { createStripeAccount } from "../../../../actions/users"
import {
  Button,
  useTheme,
} from "../../../../../node_modules/@material-ui/core/index"

const CrewDealMemoActions = ({
  crewMember = {},
  crewDealMemo = {},
  setCrewDealMemo = () => {},
}) => {
  const classes = styles()
  const dispatch = useDispatch()
  const theme = useTheme()
  let userStatus = crewMember.user_status || ""
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const hasStripeAccount =
    crewMember.stripe_account_id === null || crewMember.complete === 0
      ? false
      : true
  const companyLogo =
    crewDealMemo &&
    crewDealMemo.company_logo_image &&
    JSON.parse(crewDealMemo.company_logo_image).url

  const [acceptLoading, setAcceptLoading] = useState(false)
  const [rejectLoading, setRejectLoading] = useState(false)
  const [createLoading, setCreateLoading] = useState(false)

  // *** ACCEPT DEAL MEMO ***

  const acceptDealMemo = dialogVals => {
    setAcceptLoading(true)
    let requestObject = {
      action: "update-status-available",
      emailTo: crewDealMemo.representative_email
        ? crewDealMemo.representative_email
        : crewDealMemo.creator_email,
      //emailTo: "",
      deal_memo_signature: dialogVals.fullName,
      deal_memo_terms_accepted: Number(dialogVals.termsAccepted),
    }
    dispatch(updateCrewDealMemoStatus(requestObject, crewMember.shoot_role_id))
      .then(() => {
        setCrewDealMemo(oldState => {
          let updatedUser = {
            ...oldState.user,
            user_status: "available",
            available_date_time: moment().format(),
            deal_memo_signature: dialogVals.fullName,
            deal_memo_terms_accepted: Number(dialogVals.termsAccepted),
          }
          return { ...oldState, user: updatedUser }
        })
        setAcceptLoading(false)
        dispatch(openSnackBar({ message: "Accepted Deal Memo" }))
      })
      .catch(err => {
        console.log(err)
        setAcceptLoading(false)
        dispatch(
          openSnackBar({ message: "There was an error accepting deal memo" })
        )
      })
  }

  const openSignatureDialog = async () => {
    let data = {
      headerLogo: companyLogo,
      acceptFunc: acceptDealMemo,
      hasStripeAccount: hasStripeAccount,
    }
    Object.keys(authenticatedUser).length > 0
      ? dispatch(toggleDigitalSignatureDialog(true, data))
      : dispatch(_toggleLoginDialog(true))
  }
  // *** ACCEPT DEAL MEMO END ***

  // *** REJECT DEAL MEMO  ***

  const rejectDealMemo = dialogVals => {
    setRejectLoading(true)
    const requestData = {
      action: "update-status-rejected",
      emailTo: dialogVals.recipients.join(", "), // needs to send as "1,2", not ["1","2"]
      //emailTo: "",
      subject: dialogVals.subject,
      message: dialogVals.message,
    }
    dispatch(updateCrewDealMemoStatus(requestData, crewMember.shoot_role_id))
      .then(() => {
        setRejectLoading(false)
        setCrewDealMemo(oldState => {
          let updatedUser = {
            ...oldState.user,
            user_status: "rejected",
            rejected_date_time: moment().format(),
          }
          return { ...oldState, user: updatedUser }
        })
        dispatch(
          openSnackBar({
            message: `Report successfully sent to ${
              crewDealMemo.company_name
            } staff`,
          })
        )
      })
      .catch(err => {
        console.log(err)
        setRejectLoading(false)
        dispatch(
          openSnackBar({ message: "There was an error rejecting deal memo" })
        )
      })
  }

  const openRejectionDialog = () => {
    let defaultRejectEmail =
      crewDealMemo.representative_email || crewDealMemo.creator_email
        ? (crewDealMemo.representative_email || crewDealMemo.creator_email)
            .split(",")
            .map(x => x.trim())
        : null
    let data = {
      type: "reject",
      shootName: crewDealMemo.shoot_name,
      sendFunc: rejectDealMemo,
      defaultEmail: defaultRejectEmail,
    }
    Object.keys(authenticatedUser).length > 0
      ? dispatch(toggleSendBillingDialog(true, data))
      : dispatch(_toggleLoginDialog(true))
  }
  // *** REJECT DEAL MEMO  ***

  const handleConnectStripe = () => {
    if (
      Object.keys(authenticatedUser).length > 0 &&
      authenticatedUser.id === crewDealMemo.user.user_id
    ) {
      setCreateLoading(true)
      dispatch(createStripeAccount())
        .then(res => {
          if (res.hasOwnProperty("url")) {
            window.open(res.url.url)
          }
          if (res.message === "User are gtt member.") {
            dispatch(openSnackBar({ message: "User are gtt member" }))
          }
          setCreateLoading(false)
        })
        .catch(error => {
          console.log("error", error)
          setCreateLoading(false)
        })
    } else {
      dispatch(_toggleLoginDialog(true))
    }
  }

  if (userStatus === "sent" || userStatus === "unsent") {
    return (
      <>
        <Box display="flex" flexDirection="column">
          <Box alignSelf="center" width="80%" mt={3}>
            <GreenButton
              variant="contained"
              fullWidth
              onClick={openSignatureDialog}
            >
              {acceptLoading ? (
                <CircularProgress
                  size={20}
                  style={{ color: "#fff", margin: "4px 0" }}
                />
              ) : (
                "Accept Deal Memo"
              )}
            </GreenButton>
            <LoadingButton
              variant="contained"
              fullWidth
              onClick={openRejectionDialog}
              disabled={rejectLoading}
              style={{
                marginTop: "14.5px",
              }}
            >
              {rejectLoading ? (
                <CircularProgress
                  size={20}
                  style={{ color: "#fff", margin: "4px 0" }}
                />
              ) : (
                "Reject Deal Memo"
              )}
            </LoadingButton>
          </Box>
        </Box>
        {!hasStripeAccount && (
          <Box display="flex" justifyContent="center">
            <Card
              style={{
                marginTop: "50px",
                display: "flex",
                justifyContent: "center",
                border: `2px solid ${theme.palette.error.main}`,
                width: "80%",
              }}
            >
              <Box width="60%" marginTop="20px">
                <Typography variant="h3">Connect to Stripe</Typography>
                <Typography variant="subtitle1" style={{ marginTop: "15px" }}>
                  To be paid you need to create an account in Stripe
                </Typography>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleConnectStripe}
                  disabled={createLoading}
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                >
                  Connect to Stripe
                </Button>
              </Box>
            </Card>
          </Box>
        )}
      </>
    )
  } else {
    return (
      <>
        <Card style={{ padding: "20px" }}>
          <Box display="flex" flexDirection="column" mt={2} mb={2}>
            {(userStatus === "available" ||
              userStatus === "bill_requested" ||
              userStatus === "bill_accepted" ||
              userStatus === "approved") && (
              <Fragment>
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                >
                  <Typography variant="h3">Deal Memo Accepted</Typography>
                  <Box className={classes.acceptedDot}>
                    <CheckIcon className={classes.icon} />
                  </Box>
                </Box>
                {crewDealMemo.user.available_date_time && (
                  <Box>
                    <Typography
                      variant="subtitle1"
                      style={{ textAlign: "left" }}
                    >
                      by {crewDealMemo.user.deal_memo_signature}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      style={{ textAlign: "left", marginBottom: 10 }}
                    >
                      on{" "}
                      {crewDealMemo.user.available_date_time &&
                        moment(crewDealMemo.user.available_date_time).format(
                          "M/D/YY[ @ ]h:mm A"
                        )}
                    </Typography>
                  </Box>
                )}

                <Typography variant="subtitle1" style={{ textAlign: "left" }}>
                  Nothing else is needed until the shoot wraps. Remember to keep
                  track of your expenses.
                </Typography>
              </Fragment>
            )}
            {userStatus === "rejected" && (
              <Fragment>
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                >
                  <Typography variant="h3">Deal Memo Rejected</Typography>
                  <Box className={classes.rejectedDot}>
                    <CloseIcon className={classes.icon} />
                  </Box>
                </Box>
                <Typography
                  variant="subtitle1"
                  style={{ textAlign: "left", marginBottom: 10 }}
                >
                  on{" "}
                  {moment(crewDealMemo.user.rejected_date_time).format(
                    "M/D/YY[ @ ]h:mm A"
                  )}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "left" }}>
                  You have opted not to participate in this show.{" "}
                  {crewDealMemo.company_name} staff will review the reasons you
                  sent for rejecting this shoot and contact you if needed.
                </Typography>
              </Fragment>
            )}
          </Box>
        </Card>
        {!hasStripeAccount && (
          <Box display="flex" justifyContent="center">
            <Card
              style={{
                marginTop: "50px",
                display: "flex",
                justifyContent: "center",
                border: `2px solid ${theme.palette.error.main}`,
                width: "80%",
              }}
            >
              <Box width="60%" marginTop="20px">
                <Typography variant="h3">Connect to Stripe</Typography>
                <Typography variant="subtitle1" style={{ marginTop: "15px" }}>
                  To be paid you need to create an account in Stripe
                </Typography>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleConnectStripe}
                  disabled={createLoading}
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                >
                  Connect to Stripe
                </Button>
              </Box>
            </Card>
          </Box>
        )}
      </>
    )
  }
}

CrewDealMemoActions.propTypes = {
  crewMember: PropTypes.object,
  crewDealMemo: PropTypes.object,
  setCrewDealMemo: PropTypes.func,
}

export default CrewDealMemoActions
